import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import messages_en from '../locale/en.json'
import messages_fr from '../locale/fr.json'
import messages_fr_FR from '../locale/fr_FR.json'

export function mapStateToProps(state) {
	const { locale } = state.locale
	const intlConfig = {
		locale: getProviderLocale(locale),
		key: getProviderLocale(locale),
		messages: getMessages(locale),
	}
	return intlConfig
}

export function getMessages(locale) {
	if (locale === 'fr') {
		return messages_fr
	} else if (locale === 'fr_FR') {
		return messages_fr_FR
	}
	return messages_en
}

export function getProviderLocale(locale) {
	if (locale === 'fr') {
		return 'fr'
	} else if (locale === 'fr_FR') {
		return 'fr-FR'
	}
	return 'en'
}

export default connect(mapStateToProps)(IntlProvider)
